// Propósito: helpers de sesión para el guard de autenticación.
import { Router } from '@angular/router';
import { StorageService } from '@services/core/storage.service';

// Indica si existe sesión marcada como logueada.
export function hasSession(storage: StorageService): boolean {
  return Boolean(storage.getJsonValue('logged'));
}

// Redirige al inicio cuando el acceso es denegado.
export function denyHome(router: Router) {
  return router.parseUrl('/');
}

// Mensaje cuando el rol no tiene menús asignados.
export function emptyMenuMessage(): string {
  return 'Tu rol no tiene menús asignados. Pide al administrador que los configure.';
}

// Redirige al inicio avisando que faltan menús.
export function denyEmptyMenu(router: Router, toast: { warning(message: string): void }) {
  toast.warning(emptyMenuMessage());
  return denyHome(router);
}
